import React from 'react';
import {styled} from '@mui/material/styles';

const KpiSvg = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44.476"
    height="37.793"
    viewBox="0 0 44.476 37.793"
    {...props}
  >
    <g
      id="Group_4508"
      data-name="Group 4508"
      transform="translate(-1291.166 21206.127)"
    >
      <path
        id="Path_29939"
        data-name="Path 29939"
        d="M547.642,138.028H503.166v-30.7h44.476Zm-42.836-1.639H546V108.971h-41.2Z"
        transform="translate(788 -21313.459)"
      />
      <path
        id="Path_29940"
        data-name="Path 29940"
        d="M539.721,152.854h-1.64v-1.007H517.192v1.007h-1.64v-2.647h24.169Z"
        transform="translate(785.767 -21321.188)"
      />
      <path
        id="Path_29941"
        data-name="Path 29941"
        d="M534.211,151.216H524.169v-4.509h1.64v2.869h6.763v-2.869h1.64Z"
        transform="translate(784.214 -21320.557)"
      />
      <rect
        id="Rectangle_1741"
        data-name="Rectangle 1741"
        width="2.303"
        height="1.639"
        transform="translate(1329.885 -21202.574)"
      />
      <rect
        id="Rectangle_1742"
        data-name="Rectangle 1742"
        width="2.303"
        height="1.639"
        transform="translate(1326.125 -21202.574)"
      />
      <rect
        id="Rectangle_1743"
        data-name="Rectangle 1743"
        width="2.303"
        height="1.639"
        transform="translate(1322.365 -21202.574)"
      />
      <path
        id="Path_29942"
        data-name="Path 29942"
        d="M523.361,133.745h-4.48v-2.683a6.889,6.889,0,0,1-2.294-1.326l-2.324,1.342-2.24-3.879,2.321-1.34a6.819,6.819,0,0,1,0-2.654l-2.321-1.339,2.24-3.88,2.324,1.342A6.872,6.872,0,0,1,518.881,118V115.32h4.48V118a6.881,6.881,0,0,1,2.294,1.325l2.325-1.342,2.24,3.88-2.322,1.339a6.819,6.819,0,0,1,0,2.654l2.322,1.34-2.24,3.879-2.325-1.342a6.9,6.9,0,0,1-2.294,1.326Zm-2.84-1.639h1.2V129.8l.628-.151a5.25,5.25,0,0,0,2.589-1.494l.445-.469,2,1.153.6-1.039-1.993-1.15.183-.62a5.231,5.231,0,0,0,0-2.995l-.183-.619,1.993-1.151-.6-1.039-2,1.153-.445-.468a5.243,5.243,0,0,0-2.589-1.494l-.628-.152v-2.305h-1.2v2.305l-.629.152a5.241,5.241,0,0,0-2.588,1.494l-.445.468-2-1.153-.6,1.039,1.994,1.152-.184.619a5.224,5.224,0,0,0,0,2.993l.184.62-1.994,1.151.6,1.039,2-1.153.445.469a5.247,5.247,0,0,0,2.588,1.494l.629.151Z"
        transform="translate(786.403 -21314.898)"
      />
      <path
        id="Path_29943"
        data-name="Path 29943"
        d="M522.415,129.068a3.217,3.217,0,1,1,3.217-3.217,3.221,3.221,0,0,1-3.217,3.217m0-4.795a1.578,1.578,0,1,0,1.578,1.577,1.579,1.579,0,0,0-1.578-1.577"
        transform="translate(785.11 -21316.217)"
      />
      <path
        id="Path_29944"
        data-name="Path 29944"
        d="M537.1,135.525a2.685,2.685,0,1,1,2.685-2.685,2.688,2.688,0,0,1-2.685,2.685m0-3.731a1.046,1.046,0,1,0,1.046,1.046,1.047,1.047,0,0,0-1.046-1.046"
        transform="translate(782.366 -21317.572)"
      />
      <path
        id="Path_29945"
        data-name="Path 29945"
        d="M541.154,126.53a3.313,3.313,0,1,1,3.313-3.313,3.317,3.317,0,0,1-3.313,3.313m0-4.986a1.674,1.674,0,1,0,1.673,1.673,1.676,1.676,0,0,0-1.673-1.673"
        transform="translate(781.75 -21315.725)"
      />
      <rect
        id="Rectangle_1744"
        data-name="Rectangle 1744"
        width="1.639"
        height="1.88"
        transform="translate(1322.084 -21196.881)"
      />
      <rect
        id="Rectangle_1745"
        data-name="Rectangle 1745"
        width="1.639"
        height="1.88"
        transform="matrix(0.707, -0.707, 0.707, 0.707, 1319.232, -21195.021)"
      />
      <rect
        id="Rectangle_1746"
        data-name="Rectangle 1746"
        width="1.88"
        height="1.639"
        transform="translate(1318.531 -21193.328)"
      />
      <rect
        id="Rectangle_1747"
        data-name="Rectangle 1747"
        width="1.879"
        height="1.639"
        transform="matrix(0.707, -0.707, 0.707, 0.707, 1319.233, -21189.996)"
      />
      <rect
        id="Rectangle_1748"
        data-name="Rectangle 1748"
        width="1.639"
        height="1.88"
        transform="translate(1322.084 -21190.016)"
      />
      <rect
        id="Rectangle_1749"
        data-name="Rectangle 1749"
        width="1.64"
        height="1.88"
        transform="translate(1324.087 -21190.164) rotate(-45.018)"
      />
      <rect
        id="Rectangle_1750"
        data-name="Rectangle 1750"
        width="1.88"
        height="1.639"
        transform="translate(1325.397 -21193.328)"
      />
      <rect
        id="Rectangle_1751"
        data-name="Rectangle 1751"
        width="1.88"
        height="1.639"
        transform="matrix(0.707, -0.707, 0.707, 0.707, 1324.087, -21194.852)"
      />
    </g>
  </svg>
);
const CssKpiSvg = styled(KpiSvg)(({theme}) => ({
  fill: theme.palette.text.secondary,
  height: 'auto',
  maxHeight: 'calc(1vh + 1.7vw)',
  width: ' 100%',
}));

export default CssKpiSvg;
